import { TaxDocumentSummaryContainer } from './TaxDocumentSummary';

export default TaxDocumentSummaryContainer;
